import React from 'react'
import { MenuItem, TextField, Grid } from '@mui/material'
import { ruleValidation } from './customFunctions'
import { makeStyles, withStyles } from '@mui/styles';

const CssTextField = withStyles({
    root: {
      
      '& label.Mui-focused': {

        //color: 'green',
      },
      '& .MuiInput-underline:after': {
        //borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        padding:'8px 0px',
       // borderRadius:12,
        '& fieldset': {
          borderColor: '#4F4F4F',
          //borderColor: 'red',
        },
        '&:hover fieldset': {
          //borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          //borderColor: 'green',
        },
      },
    },
  })(TextField);

  const InputSelectForm = props => {


    const {data, onChange, startAdornment, endAdornment} = props

    const onInnerChange = event => {
        const response = event.target.value;
        let temp = {...data};
        temp.value = response;
        temp.isValid = ruleValidation(temp.value, temp.rules, temp.value2);
        temp.isVisited = true;
        onChange(temp);
    } 

    const {config, value, isValid, isVisited, options} = data

    const isError = isVisited && !isValid
    let interConfig = {...config}
    if(!isError) interConfig.helperText = ''

    const _options = options ? options : []

    return(
        <div>
            <CssTextField  value={value} variant='outlined'  margin='none' size='small'
            error={isError} {...interConfig} select onChange={onInnerChange} 
            InputProps={
                {
                    startAdornment:startAdornment ? startAdornment : undefined,
                    endAdornment:endAdornment ? endAdornment : undefined,
                }}
            >
                {_options.map(item => {
                    return(
                        <MenuItem key={item.value.toString()} dense spacing={1} value={item.value} >
                          <Grid container alignItems='center' wrap='nowrap' >
                            {item.img ? (
                              <Grid item>
                                <img src={item.img} width={24}/>
                              </Grid>
                            ) : null}
                            <Grid item>
                              {item.label}
                            </Grid>
                          </Grid>
                          
                        </MenuItem>
                    )
                })}
            </CssTextField>
        </div>
    )
}

export default InputSelectForm